import IpubEditor from './src/main'

/* istanbul ignore next */
IpubEditor.install = function(Vue) {
  Vue.component(IpubEditor.name, IpubEditor)
}

export default IpubEditor
